import { render, staticRenderFns } from "./post_react.vue?vue&type=template&id=23a78987&scoped=true&"
import script from "./post_react.vue?vue&type=script&lang=js&"
export * from "./post_react.vue?vue&type=script&lang=js&"
import style0 from "./post_react.vue?vue&type=style&index=0&id=23a78987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a78987",
  null
  
)

export default component.exports